export const ArchiveIcon = () => {
  return (
    <svg
      className="hover:text-darkblue text-[#9CA3AF]"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="currentColor"
    >
      <path
        d="M12.0802 3.31725L12.1738 3.49564H12.3753H21.0378C22.1358 3.49564 23.0295 4.36592 23.0295 5.44981V19.2873C23.0295 20.3782 22.1662 21.2415 21.0753 21.2415H2.96279C1.87189 21.2415 1.00863 20.3782 1.00863 19.2873V2.7123C1.00863 1.6214 1.87189 0.758138 2.96279 0.758138H9.56279C10.2915 0.758138 10.9344 1.16809 11.2942 1.82022L12.0802 3.31725ZM21.0753 20.2206C21.5969 20.2206 22.0086 19.8089 22.0086 19.2873V5.44981C22.0086 4.92821 21.5969 4.51647 21.0753 4.51647H11.8878C11.7185 4.51647 11.5255 4.40351 11.429 4.23761L10.3835 2.29583C10.2163 1.96555 9.91735 1.77897 9.56279 1.77897H2.96279C2.4412 1.77897 2.02946 2.19071 2.02946 2.7123V19.2873C2.02946 19.8089 2.4412 20.2206 2.96279 20.2206H21.0753Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.666667"
      />
      <path
        d="M12.6004 8.14961C12.2629 7.81211 11.7379 7.81211 11.4004 8.14961L8.13789 11.3746C7.80039 11.7121 7.80039 12.2371 8.13789 12.5746C8.47539 12.9121 9.00039 12.9121 9.33789 12.5746L11.1754 10.7746V16.2496C11.1754 16.6996 11.5504 17.1121 12.0379 17.1121C12.5254 17.1121 12.8629 16.7371 12.8629 16.2496V10.7371L14.7379 12.5746C14.8879 12.7246 15.1129 12.7996 15.3379 12.7996C15.5629 12.7996 15.7879 12.7246 15.9379 12.5371C16.2754 12.1996 16.2754 11.6746 15.9379 11.3371L12.6004 8.14961Z"
        fill="currentColor"
      />
    </svg>
  );
};
